import styled from 'styled-components';

export const ProfileSelectionPopupWrapper = styled.div`
 display: flex;
`;
